import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="mt-16 pt-8 border-t border-gray-200 dark:border-gray-600">
      <div className="max-w-4xl mx-auto px-4">
        {/* Quick Links */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200 mb-4">
              {t('footer.quickLinks')}
            </h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/" 
                  className="text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200"
                >
                  {t('footer.calculator')}
                </Link>
              </li>
              <li>
                <Link 
                  to="/pilot-upgrade-calculator" 
                  className="text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200"
                >
                  {t('footer.pilotCalculator')}
                </Link>
              </li>
              <li>
                <Link
                  to="/mod-calculator"
                  className="text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200"
                >
                  {t('footer.modCalculator')}
                </Link>
              </li>
              <li>
                <Link 
                  to="/my-stats" 
                  className="text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200"
                >
                  {t('footer.statistics')}
                </Link>
              </li>
              <li>
                <Link 
                  to="/legendary-skins" 
                  className="text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200"
                >
                  {t('footer.legendarySkins')}
                </Link>
              </li>
              <li>
                <a 
                  href="/privacy-policy.html" 
                  className="text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200"
                >
                  {t('footer.privacyPolicy')}
                </a>
              </li>
              <li>
                <a 
                  href="/terms-of-use.html" 
                  className="text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200"
                >
                  {t('footer.termsOfUse')}
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200 mb-4">
              {t('footer.support')}
            </h3>
            <ul className="space-y-2">
              <li>
                <a 
                  href="https://forms.gle/ysNkm9FaewMtz2yS6" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  onClick={() => {
                    if (typeof gtag !== 'undefined') {
                      gtag('event', 'external_link_click', {
                        'link_destination': 'feedback_form',
                        'link_location': 'footer'
                      });
                    }
                  }}
                  className="text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200"
                >
                  {t('footer.feedback')}
                </a>
              </li>
              <li>
                <a 
                  href="#contact" 
                  className="text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200"
                >
                  {t('footer.contact')}
                </a>
              </li>
              <li>
                <a 
                  href="#help" 
                  className="text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200"
                >
                  {t('footer.help')}
                </a>
              </li>
              <li>
                <a
                  href="https://www.paypal.com/paypalme/elearningexpert"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => {
                    if (typeof gtag !== 'undefined') {
                      gtag('event', 'external_link_click', {
                        'link_destination': 'support_project',
                        'link_location': 'footer'
                      });
                    }
                  }}
                  className="text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200"
                >
                  {t('footer.supportProject') || 'Support Project'}
                </a>
              </li>
              <li>
                <a
                  href="https://discord.gg/unPEn5tZk2"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => {
                    if (typeof gtag !== 'undefined') {
                      gtag('event', 'external_link_click', {
                        'link_destination': 'discord_server',
                        'link_location': 'footer'
                      });
                    }
                  }}
                  className="inline-flex items-center gap-1.5 text-gray-600 dark:text-gray-300 hover:text-indigo-600 dark:hover:text-[#FF8A65] transition-colors duration-200"
                >
                  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515a.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0a12.64 12.64 0 0 0-.617-1.25a.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057a19.9 19.9 0 0 0 5.993 3.03a.078.078 0 0 0 .084-.028a14.09 14.09 0 0 0 1.226-1.994a.076.076 0 0 0-.041-.106a13.107 13.107 0 0 1-1.872-.892a.077.077 0 0 1-.008-.128a10.2 10.2 0 0 0 .372-.292a.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.074.074 0 0 1-.006.127a12.299 12.299 0 0 1-1.873.892a.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028a19.839 19.839 0 0 0 6.002-3.03a.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.956-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.955-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.946 2.418-2.157 2.418z"/>
                  </svg>
                  Join Discord
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200 mb-4">
              {t('footer.about')}
            </h3>
            <p className="text-gray-600 dark:text-gray-300 text-sm mb-4">
              {t('footer.description')}
            </p>
          </div>
        </div>
        
      </div>
    </footer>
  );
};

export default Footer;
